import HubspotForm from 'components/Form/HubspotForms';
import InlineSubscribeForm from 'components/Form/InlineSubscribeForm';

import type { ContentfulAsset, ContentfulComponentForm } from 'graphqlTypes';
import type { FC } from 'react';

interface ComponentFormProps
  extends Omit<ContentfulComponentForm, 'id' | 'children' | 'contentful_id' | 'internal' | 'node_locale'> {
  backgroundIsDark?: boolean;
  assetData?: ContentfulAsset;
}

const Form: FC<ComponentFormProps> = ({ formType, backgroundIsDark, assetData, ...props }) => {
  switch (formType) {
    case 'Basic':
      return <HubspotForm {...props} />;
    case 'Download PDF':
      return <HubspotForm assetData={assetData} isDownloadPDF {...props} />;
    case 'Inline Subscribe':
      return <InlineSubscribeForm backgroundIsDark={backgroundIsDark} {...props} />;
    default:
      return null;
  }
};

export default Form;
